/**
 * Check whether input is a Map
 */
export const isMap = (input: any): boolean =>
	input instanceof Map || (input && input.toString() === "[object Map]");
/**
 * Check whether input is a Set
 */
export const isSet = (input: any): boolean =>
	input instanceof Set || (input && input.toString() === "[object Set]");
/**
 * Check whether input is a Date
 */
export const isDate = (input: any): boolean =>
	input instanceof Date || (input && typeof input.toDateString === "function");
